export default __webpack_public_path__ + "static/media/our-values-HEADER-Tablet.9cd07600.jpg";